export const URL_REFRESH_TOKEN = `/merchant-tokens/refresh-token`;
export const URL_AUTH_OTP = `/account/otp-auth`;
export const URL_VERIFICATION_AUTH_OTP = `/account/otp-auth-verification?otp_key=%(otp_key)s`;
export const URL_RESEND_AUTH_OTP = `/account/resend-otp?otp_key=%(otp_key)s`;
export const URL_SIGN_IN = `/account/sign-in?access_key=%(access_key)s`;
export const URL_SIGN_UP = `/account/sign-up?access_key=%(access_key)s`;
export const URL_SIGN_OUT = `/account/sign-out`;
